import { Component, Input } from '@angular/core';
import { SpinnerComponent } from '@spartacus/storefront';

@Component({
    selector: 'knbr-cwt-spinner',
    templateUrl: './cwt-spinner.component.html',
    styleUrl: './cwt-spinner.component.scss',
})
export class CwtSpinnerComponent extends SpinnerComponent{
@Input() calssName : string = '';
}
